// ─── User message (right, green) ────────────────────────────────────────────
.userRow {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  gap: var(--hcr-spacing-2);
}

.userStack {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: var(--hcr-spacing-1);
  max-width: 80%;
}

.userBubble {
  // Honeycomb's light-green highlight tint (same family as the sparkle-avatar
  // tint), dark text on top.
  background-color: var(--hcr-highlight-color);
  color: var(--hcr-content-primary-color);
  border-radius: var(--hcr-primary-border-radius);
  padding: var(--hcr-spacing-2) var(--hcr-spacing-3);
}

.userAvatar {
  flex: 0 0 auto;
}

// ─── Scope card (opening "header" summary, right side) ──────────────────────
// The calculation header the user set in the wizard, as readable label→value
// rows rather than a cramped dot-joined string.
.scopeCard {
  margin: 0;
  max-width: 80%;
  background-color: var(--hcr-highlight-color);
  color: var(--hcr-content-primary-color);
  border-radius: var(--hcr-primary-border-radius);
  padding: var(--hcr-spacing-2) var(--hcr-spacing-3);
  display: flex;
  flex-direction: column;
  gap: var(--hcr-spacing-1);
}

.scopeRow {
  display: flex;
  justify-content: space-between;
  gap: var(--hcr-spacing-3);
}

.scopeLabel {
  margin: 0;
  color: var(--hcr-content-secondary-color);
  font-size: var(--hcr-font-size-small);
  white-space: nowrap;
}

.scopeValue {
  margin: 0;
  font-weight: bold;
  text-align: right;
}

// ─── Assistant message (left, with sparkle avatar) ──────────────────────────
.assistantRow {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: var(--hcr-spacing-2);
}

.assistantAvatar {
  flex: 0 0 auto;
  background-color: var(--hcr-highlight-color);
  color: var(--hcr-ui-primary-color);
  border-radius: 50%;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--hcr-spacing-1);
}

.assistantBubble {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--hcr-spacing-2);
}

.bubbleText {
  margin: 0;
}

.assistantMeta {
  color: var(--hcr-content-secondary-color);
  margin: 0;
}

.bubbleActions {
  margin-top: var(--hcr-spacing-1);
}

// ─── File chips (submitted user bubble) ─────────────────────────────────────
.fileChip {
  display: inline-flex;
  align-items: center;
  gap: var(--hcr-spacing-1);
  padding: var(--hcr-spacing-1) var(--hcr-spacing-2);
  border: 1px solid var(--hcr-line-primary-color);
  border-radius: var(--hcr-primary-border-radius);
  background-color: var(--hcr-box-bg-color);
  font-size: var(--hcr-font-size-small);
  max-width: 100%;
}

.fileChipName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// ─── Typing indicator (running) ─────────────────────────────────────────────
.typing {
  display: flex;
  align-items: flex-start;
  gap: var(--hcr-spacing-2);
}

.typingStatus {
  color: var(--hcr-content-secondary-color);
  margin: 0;
}

.typingHint {
  color: var(--hcr-content-secondary-color);
  margin: var(--hcr-spacing-half) 0 0;
}

.typingDots {
  display: inline-flex;
  align-items: center;
  gap: var(--hcr-spacing-half);
  // Nudge the dots down to sit on the first status line now that the text block
  // spans two lines (status + patience hint).
  padding-top: var(--hcr-spacing-1);

  span {
    width: var(--hcr-spacing-1);
    height: var(--hcr-spacing-1);
    border-radius: 50%;
    background-color: var(--hcr-ui-primary-color);
    animation: typing-bounce 1.4s infinite ease-in-out both;
  }

  span:nth-child(1) {
    animation-delay: -0.32s;
  }
  span:nth-child(2) {
    animation-delay: -0.16s;
  }
}

@keyframes typing-bounce {
  0%,
  80%,
  100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .typingDots span {
    animation: none;
  }
}
